const storageHelper = {
    setUser: (user) => {
        const { name, lastname, email, urlImage, token, role, phone, _id } = user
        const userToStore = {
            _id,
            name,
            lastname,
            email,
            urlImage,
            token,
            role,
            phone,
        }
        window.localStorage.setItem('user', JSON.stringify(userToStore))
    },

    setToken: (token) => {
        try {
            if (!token) {
                window.sessionStorage.removeItem('token')
                try {
                    window.localStorage.removeItem('token')
                } catch (e) {
                    // ignore
                }
                return false
            }
            // Save in sessionStorage for per-tab isolation
            window.sessionStorage.setItem('token', JSON.stringify(token))
            // Remove legacy localStorage token if present to avoid cross-tab leaks
            try {
                window.localStorage.removeItem('token')
            } catch (e) {
                // ignore
            }
            return token
        } catch (e) {
            return false
        }
    },

    getToken: () => {
        // Prefer sessionStorage (per-tab)
        const rawSession = window.sessionStorage.getItem('token')
        if (rawSession) {
            try {
                return JSON.parse(rawSession)
            } catch {
                // Migración: token legacy sin serializar en sessionStorage
                if (typeof rawSession === 'string' && rawSession.trim().length > 0) {
                    try {
                        window.sessionStorage.setItem('token', JSON.stringify(rawSession))
                    } catch (e) {
                        // ignore storage errors
                    }
                    return rawSession
                }
                try {
                    window.sessionStorage.removeItem('token')
                } catch (e) {
                    // ignore
                }
                return null
            }
        }

        // Fall back to legacy localStorage token once: migrate it into sessionStorage
        try {
            const legacy = window.localStorage.getItem('token')
            if (!legacy) return null
            try {
                const parsed = JSON.parse(legacy)
                window.sessionStorage.setItem('token', JSON.stringify(parsed))
                try {
                    window.localStorage.removeItem('token')
                } catch (e) {
                    // ignore
                }
                return parsed
            } catch {
                // not JSON - treat as raw string
                if (typeof legacy === 'string' && legacy.trim().length > 0) {
                    window.sessionStorage.setItem('token', JSON.stringify(legacy))
                    try {
                        window.localStorage.removeItem('token')
                    } catch (e) {
                        // ignore
                    }
                    return legacy
                }
                try {
                    window.localStorage.removeItem('token')
                } catch (e) {
                    // ignore
                }
                return null
            }
        } catch (e) {
            return null
        }
    },

    setRole: (role) => {
        if (!role) {
            return false
        }
        window.localStorage.setItem('role', role)
        return role
    },

    getRole: () => {
        return window.localStorage.getItem('role')
    },

    setItem: (itemName, value) => {
        window.localStorage.setItem(itemName, value)
    },

    getItem: (itemName) => {
        return window.localStorage.getItem(itemName)
    },

    getUser: () => {
        try {
            return JSON.parse(window.localStorage.getItem('user'))
        } catch (error) {
            return null
        }
    },

    setHasLoggedOut: (value) => {
        try {
            if (value) {
                window.sessionStorage.setItem('hasLoggedOut', JSON.stringify(true))
            } else {
                window.sessionStorage.removeItem('hasLoggedOut')
            }
            return true
        } catch (e) {
            return false
        }
    },

    getHasLoggedOut: () => {
        try {
            const raw = window.sessionStorage.getItem('hasLoggedOut')
            if (!raw) return false
            return JSON.parse(raw) === true
        } catch (e) {
            return false
        }
    },

    /**
     * Limpieza de sesión (logout selectivo)
     * Mantiene localStorage.user para UX de re-login rápido
     */
    clearSession: () => {
        // Remove token from sessionStorage and any legacy localStorage entry
        try {
            window.sessionStorage.removeItem('token')
        } catch (e) {
            // ignore
        }
        try {
            window.localStorage.removeItem('token')
        } catch (e) {
            // ignore
        }
    },

    /**
     * Limpieza total (cambio de cuenta)
     */
    clearAll: () => {
        window.sessionStorage.clear()
        window.localStorage.clear()
    },

    // Alias para compatibilidad
    clear: () => {
        storageHelper.clearSession()
    },
}

export default storageHelper
